import React from 'react';
import { Redirect } from 'react-router-dom';

export const HomePage: React.FC = () => {
	return <Redirect to='/pages' />;
};
